import { useStageStore } from "@/stores/stage"

const useHelpers = () => {

    const stageStore = useStageStore()

    const hasAccess = (stageId) => {

        if (!stageId) {
            return false;
        }
        
        const targetStage = stageStore.getStageById(stageId)[0];

        const mapAccess = targetStage?.access?.map;
        const questionAccess = targetStage?.access?.question;
        const questionAccessAllowedByRelations = targetStage?.access?.questionAccessAllowedByRelations;
        if (!mapAccess || !questionAccess || !questionAccessAllowedByRelations) {
            // Check if stage entry should be allowed through question type
            const isDoneByDefault = targetStage?.node?.components[0].type === 'doneByDefault';
            if (!isDoneByDefault) {
                return false;
            }
        }
        
        return true;
    }

    return {
        hasAccess
    }
}

export default useHelpers